module.exports = __webpack_public_path__ + "assets/images/kobieBrown1.03193681.jpg";